<app-field
  class="field"
  [name]="'components.searchCitiesView.fields.city' | translate"
  [class.tui-skeleton]="loading"
  [class.tui-skeleton_text]="loading"
  [typeName]="'text'"
  [value]="city?.city"
  [size]="size"
></app-field>
